import { atom, useAtom } from 'jotai';

type MapColor = 'light' | 'dark';

type UseMapColor = {
  mapColor: MapColor;
  setMapColor: (color: MapColor) => void;
};

const mapColorAtom = atom<MapColor>('light');

const useMapColor = (): UseMapColor => {
  const [mapColor, setMapColor] = useAtom(mapColorAtom);

  return {
    mapColor,
    setMapColor,
  };
};

export { useMapColor };
